import Button from "../components/Button";
import { Link, Navigate } from "react-router-dom";
import Logo from "../components/Logo";
import BandCard from "../components/BandCard";
import { useEffect, useState } from "react";
import { useHeaderContext } from "../context/headerContext";
import { useThemeContext } from "../context/themeContext";
import { useDrawerContext } from "../context/drawerContext";
import ContentCard from "../components/ContentCard";
import IncidentIcon from "/public/images/icons/emergencyBandScan.svg?react";
import LocationPinIcon from "/public/images/icons/locationPin.svg?react";
//import BookingsIcon from "/public/images/icons/bookings.svg?react";
import CloseIcon from "/public/images/icons/close.svg?react";
import InfoIcon from "/public/images/icons/infoIcon.svg?react";
import { useUserContext } from "../context/userContext";
// import generateUUID from "../utils/generateUUID";
import SelectInput from "../components/SelectInput";
import { useNavigate } from "react-router";
import ParticipantCard from "../components/ParticipantCard";
import { fetchWithRefresh } from "../utils/fetchWithRefresh";
import UpgradeAvailable from "../components/UpgradeAvailable";
import { useLiteDrawer } from "../hooks/useLiteDrawer";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../utils/LogErrors";

export default function Home() {
  const { theme } = useThemeContext();
  const { setTitle, setCartButton, setCartButtonFunc, setBackButton } = useHeaderContext();
  const { setOpen, setDrawerContent } = useDrawerContext();
  const { showLiteDrawer } = useLiteDrawer();
  const { user, logout, updateTokens, participants, refreshSubscription, refreshParticipants, selectedZone, setSelectedZone, selectedVenue, setSelectedVenue } = useUserContext();
  const [incidents, setIncidents] = useState(null);
  const [participantCounts, setParticipantCounts] = useState(null);
  const [venueCleared, setVenueCleared] = useState(false);
  const Navigate = useNavigate();
  const [prompt, setPrompt] = useState(null);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  useEffect(() => {
    setTitle("HOME");
    setBackButton(false);
    if (theme === 'participant'){
      setCartButton(true);

    const handleBack = () => {
      Navigate('/cart');
    };

    setCartButtonFunc(handleBack);
    } else {
      setCartButton(false);
    }
  }, []);


  useEffect(() => {
    if (theme === 'participant') {
      refreshSubscription({ onLiteSubscription: showLiteDrawer });
      refreshParticipants();
    }
  }, [theme]);

  const handleOrderBandClick = async () => {
    const freshSubscription = await refreshSubscription();
    if (freshSubscription?.Name === 'Lite') {
      window.open(freshSubscription?.LiteShopUrl || '/shop/my-participants', '_blank');
    }
  };

  const triggerZoneSelectionDrawer = async () => {
    return await Sentry.startSpan({ name: "Fetch Zone Selection Data", op: "http.request" }, async (span) => {
      try {
        const userToken = JSON.parse(localStorage.getItem("user"))?.token;
        if (!userToken) {
          Sentry.captureMessage("User token is missing", "warning");
          LogErrors(user, logout, updateTokens, "User token is missing");
          return;
        }
  
        const venueUrl = import.meta.env.VITE_API_URL + `Venue/FetchVenue?OrgID=${selectedVenue?.OrgID}`;
        span.setAttribute("venue_url", venueUrl);
  
        const venueReq = await fetchWithRefresh(venueUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        }, logout, updateTokens, (message) => { toast.info(message);});
  
        if (!venueReq.ok) {
          const errorText = await venueReq.text();
          Sentry.captureMessage(`Failed to fetch venue: ${errorText}`, "error");
          LogErrors(user, logout, updateTokens, "Error fetching venue: " + errorText);
          return;
        }
  
        const venueRes = await venueReq.json();
        const zoneUrl = import.meta.env.VITE_API_URL + `Zone/FetchActiveOrgZones?OrgID=${selectedVenue?.OrgID}`;
        span.setAttribute("zone_url", zoneUrl);
  
        const zoneReq = await fetchWithRefresh(zoneUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
        }, logout, updateTokens, (message) => { toast.info(message);});
  
        if (!zoneReq.ok) {
          const errorText = await zoneReq.text();
          Sentry.captureMessage(`Failed to fetch zones: ${errorText}`, "error");
          LogErrors(user, logout, updateTokens, "Error fetching zones: " + errorText);
          return;
        }
  
        const zoneRes = await zoneReq.json();
        const venueWithZones = { ...venueRes, zones: zoneRes.Zones };
  
        setSelectedVenue(venueWithZones);
        setOpen(true);
        setDrawerContent(
          <div className="w-full">
            <div className="flex items-center justify-between w-full">
              <br />
              <h2 className="leading-5 tracking-widest uppercase text-[12px]">Choose Zone</h2>
              <CloseIcon className="cursor-pointer" onClick={() => setOpen(false)} />
            </div>
            <div className="mt-6 flex flex-col gap-4 justify-stretch">
              <h3 className="text-[24px]">Please choose the zone you are currently located at</h3>
              <p className="text-sportsDarkGrey">You can update your zone anytime from the Home or Scan screens.</p>
              <form className="flex flex-col gap-4" onSubmit={setZone}>
                <SelectInput
                  name="zoneSelect"
                  className="capitalize"
                  options={venueWithZones?.zones?.map((zone) => (
                    <option key={zone.ZoneID} value={JSON.stringify(zone)}>
                      {zone.ZoneName}
                    </option>
                  ))}
                  label={"Your Current Zone"}
                  placeholder={"Please Select"}
                />
                <Button submit>Confirm & Continue</Button>
              </form>
            </div>
          </div>
        );
  
        span.setStatus("ok");
      } catch (error) {
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, "Error fetching zone selection data: " + error);
      }
    });
  };

  const setZone = (event) => {
    event.preventDefault();
    const selectedZone = JSON.parse(event.target.zoneSelect.value);
    setSelectedZone(selectedZone);
    setOpen(false);
  };

  useEffect(() => {
    if( theme === 'staff' && selectedVenue){
      fetchIncidents();
      fetchParticipantCounts();
      setLoggedInStaffMember();
    }
  }, [theme, selectedVenue]);

  useEffect(() => {
    if(venueCleared){
      fetchParticipantCounts();
    }
  }, [venueCleared])

  const fetchParticipantCounts = async () => {
    return await Sentry.startSpan({ name: "Fetch Participant Counts", op: "http.request" }, async (span) => {
      setVenueCleared(false);
  
      try {
        const url = `${import.meta.env.VITE_API_URL}Zone/FetchParticipantsByZone?OrgID=${selectedVenue?.OrgID}`;
        span.setAttribute("request_url", url);
  
        const zoneCountReq = await fetchWithRefresh(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }, logout, updateTokens, (message) => { toast.info(message);});
  
        if (!zoneCountReq.ok) {
          const errorText = await zoneCountReq.text();
          Sentry.captureMessage(`Failed to fetch participant counts: ${errorText}`, "error");
          LogErrors(user, logout, updateTokens, "Error fetching participant counts: " + errorText);
          return;
        }
  
        const zoneCountRes = await zoneCountReq.json();
        setParticipantCounts(zoneCountRes);
        span.setStatus("ok");
      } catch (error) {
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, "Error fetching participant counts: " + error);
      }
    });
  };
  
  const setLoggedInStaffMember = async () => {
    return await Sentry.startSpan({ name: "Set Logged-In Staff Member", op: "http.request" }, async (span) => {
      if (!selectedVenue?.OrgID || !user?.token || !user?.id || !localStorage.getItem("firebaseToken")) {
        Sentry.captureMessage(`Missing required parameters for staff login: ${selectedVenue?.OrgID} ${!user?.token} ${!user?.id} ${!localStorage.getItem("firebaseToken")}`, "log");
        // LogErrors(user, logout, updateTokens, "Missing required parameters for staff login");
        return;
      }
  
      try {
        const url = `${import.meta.env.VITE_API_URL}Staff/FetchLoggedInStaffMembers?venueId=${selectedVenue?.OrgID}`;
        span.setAttribute("request_url", url);
  
        const response = await fetchWithRefresh(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }, logout, updateTokens, (message) => { toast.info(message);});
  
        if (!response.ok) {
          const errorText = await response.text();
          Sentry.captureMessage(`Failed to fetch logged-in staff members: ${errorText}`, "error");
          //LogErrors(user, logout, updateTokens, "Error fetching logged-in staff members:", errorText);
          return;
        }
  
        const data = await response.json();
  
        const firebaseToken = localStorage.getItem("firebaseToken");

    
        const entryExists = data.some((item) => 
          item.UserId === user?.id && item.DeviceId === firebaseToken
        );

        if (!entryExists && firebaseToken) {
          try {
            const postUrl = `${import.meta.env.VITE_API_URL}Staff/AddLoggedInStaffMember`;
            span.setAttribute("post_request_url", postUrl);
  
            const postResponse = await fetchWithRefresh(postUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${user?.token}`,
              },
              body: JSON.stringify({
                venueId: selectedVenue?.OrgID.toString(),
                staffId: user?.id,
                deviceId: localStorage.getItem("firebaseToken"),
              }),
            }, logout, updateTokens, (message) => { toast.info(message);});
  
            if (!postResponse.ok) {
              const errorText = await postResponse.text();
              Sentry.captureMessage(`Failed to add logged-in staff member: ${errorText}`, "error");
              // LogErrors(user, logout, updateTokens, "Error adding logged-in staff member:", errorText);
              return;
            }
  
            localStorage.setItem("logged-in", "true");
            span.setStatus("ok");
          } catch (postError) {
            Sentry.captureException(postError);
            // LogErrors(user, logout, updateTokens, "Error adding logged-in staff member:", postError);
          }
        } else {
            Sentry.captureMessage("Entry already exists for staff member or notifications not enabled", "info");
          // LogErrors(user, logout, updateTokens, "Entry already found for staff member.");
        }
      } catch (error) {
        Sentry.captureException(error);
        // LogErrors(user, logout, updateTokens, "Error fetching logged-in staff members:", error);
      }
    });
  };
  
  const handleClearVenue = (buttonText, buttonDisabled) => {
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            CLEAR VENUE
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-2 justify-stretch">
          <h3 className="text-[24px]">Clear Venue, are you sure?</h3>
          <p className="text-sportsDarkGrey mb-[26px]">
            If you clear the venue, all participants currently checked in to the
            venue will be checked out.
          </p>
          <div className="flex flex-col gap-6">
            <Button 
              disabled={buttonDisabled}
              onClick={() => {
                if(!buttonDisabled) {
                  clearVenue();
                }
              }}
            >{buttonText}</Button>

            <Button
              status="nobg"
              disabled={buttonDisabled}
              onClick={() => {
                if(!buttonDisabled) {
                  setOpen(false);
                }
              }}
              className="!text-[#101820]"
            >
              Don&apos;t Clear Venue
            </Button>
          </div>
        </div>
      </div>
    );

    setOpen(true);
  };

  const fetchIncidents = async () => {
    return await Sentry.startSpan({ name: "Fetch Active Incidents", op: "http.request" }, async (span) => {
      try {
        const url = `${import.meta.env.VITE_API_URL}Incident/FetchActiveIncidentsForVenue?venueId=${selectedVenue?.OrgID}`;
        span.setAttribute("request_url", url);
  
        const response = await fetchWithRefresh(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }, logout, updateTokens, (message) => { toast.info(message);});
  
        if (!response.ok) {
          const errorText = await response.text();
          Sentry.captureMessage(`Failed to fetch incidents: ${errorText}`, "error");
          LogErrors(user, logout, updateTokens, "Error fetching incidents: " + errorText);
          return;
        }
  
        const data = await response.json();
        setIncidents(Array.isArray(data) ? data : [data]);
        span.setStatus("ok");
      } catch (error) {
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, "Error fetching incidents: " + error);
      }
    });
  };

  const clearVenue = async () => {
    return await Sentry.startSpan({ name: "Clear Venue", op: "http.request" }, async (span) => {
      try {
        handleClearVenue("Clearing Venue...", true);
  
        const url = `${import.meta.env.VITE_API_URL}Venue/ClearVenue?OrgID=${selectedVenue?.OrgID}`;
        span.setAttribute("request_url", url);
  
        const response = await fetchWithRefresh(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }, logout, updateTokens, (message) => { toast.info(message);});
  
        if (!response.ok) {
          const errorText = await response.text();
          Sentry.captureMessage(`Failed to clear venue: ${errorText}`, "error");
          LogErrors(user, logout, updateTokens, "Error clearing venue: " + errorText);
          return;
        }
  
        setVenueCleared(true);
        setOpen(true);
        setDrawerContent(
          <div className="w-full">
            <div className="flex items-center justify-between w-full">
              <br />
              <h2 className="leading-5 tracking-widest uppercase text-[12px]">
                CLEAR VENUE
              </h2>
              <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
            </div>
            <div className="mt-6 flex flex-col gap-2 justify-stretch">
              <h3 className="text-[24px]">Venue successfully cleared.</h3>
              <p className="text-sportsDarkGrey mb-[26px]">
                All participants at this venue have been checked out.
              </p>
            </div>
          </div>
        );
  
        span.setStatus("ok");
      } catch (error) {
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, "Error clearing venue: " + error);
      }
    });
  };

  const BeforeWeBegin = () => {
    setOpen(true);
    setDrawerContent(
      <div className="w-full">
        <div className="flex items-center justify-between w-full">
          <br />
          <h2 className="leading-5 tracking-widest uppercase text-[12px]">
            ACTIVATE BAND
          </h2>
          <CloseIcon className='cursor-pointer' onClick={() => setOpen(false)} />
        </div>
        <div className="mt-6 flex flex-col gap-2 justify-stretch">
          <h3 className="text-[24px] font-semibold">Before we begin, make sure you have your new band to hand with the QR Code visible and (if applicable):</h3>
          <ul>
            <li className="font-semibold">• Your Medical History</li>
            <li className="font-semibold">• Your Allergies</li>
            <li className="font-semibold">• Your Medications</li>
          </ul>
          <p className="text-sportsDarkGrey mb-[26px]">
            Some older smartphones may have trouble registering the band. If this issue persists, call us on <a className="font-semibold text-black underline" href="tel:0800 999 3669">0800 999 3669</a> or email us at <a className="font-semibold text-black underline" href="mailto:hello@sportsguardian.com">hello@sportsguardian.com</a>.
          </p>
          <Button variant="primary" onClick={() => Navigate('/add-band/scan')}>
            Continue
          </Button>
        </div>
      </div>
    );
  };

  const triggerClick = () => {
    Sentry.startSpan({ name: "Trigger Notification", op: "ui.interaction" }, async (span) => {
      try {
        // LogErrors(user, logout, updateTokens, "Clicked");
        const permission = await Notification.requestPermission();
        // LogErrors(user, logout, updateTokens, permission);
  
        if (permission !== "granted") {
          console.warn("Notification permission denied.");
          Sentry.captureMessage("Notification permission denied", "warning");
          return;
        }
  
        // LogErrors(user, logout, updateTokens, "Notification permission granted.");
  
        // Check if service worker is installed
        if ("serviceWorker" in navigator) {
          // LogErrors(user, logout, updateTokens, "Service worker detected.");
  
          const registration = await navigator.serviceWorker.ready;
          // LogErrors(user, logout, updateTokens, "Service Worker Ready: " + registration);
  
          if (!registration.showNotification) {
            Sentry.captureMessage("Service worker does not support notifications", "warning");
            console.warn("Service worker does not support notifications.");
            return;
          }
  
          registration.showNotification("Test Notification", {
            body: "This is a test notification",
            icon: "/images/logo.png",
          });
  
          // LogErrors(user, logout, updateTokens, "Notification sent!");
        } else {
          console.warn("Service worker not supported.");
          Sentry.captureMessage("Service worker not supported", "warning");
        }
  
        span.setStatus("ok");
      } catch (error) {
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, "Error triggering notification: " + error);
      }
    });
  };

  useEffect(() => {
    const ready = (e) => {
      e.preventDefault();
      setPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", ready);

    return () => {
      window.removeEventListener("beforeinstallprompt", ready);
    };
  }, [])
  
  const isAppInstalled = async () => {
    if ("getInstalledRelatedApps" in window.navigator) {
      const relatedApps = await navigator.getInstalledRelatedApps();
      let installed = false;
      relatedApps.forEach((app) => {
      //if your PWA exists in the array it is installed
      // LogErrors(user, logout, updateTokens, app.platform, app.url);
      if (
        app.url ===
        import.meta.env.VITE_PWA_URL + "/manifest.webmanifest"
      ) {
        installed = true;
      }
      });
      return installed;
    } else if (isSafari || navigator.userAgent.toLowerCase().includes('firefox')) {
      // LogErrors(user, logout, updateTokens, "Safari or Firefox");
      return false;
    } else {
      // LogErrors(user, logout, updateTokens, 'Not supported');
      return false;
    }
  };

    const addToHomeModal = () => {
      // Check if modal should be shown based on local storage
      const shouldShowModal = Number(localStorage.getItem("addToHomeModalShown") || 0);
      if (shouldShowModal < 3) {
        setOpen(true);
        setDrawerContent(
          <div className="w-full">
            <div className="flex items-center justify-between w-full">
              <br />
              <h2 className="leading-5 tracking-widest uppercase text-[12px]">
                ADD TO HOME SCREEN
              </h2>
              <CloseIcon className='cursor-pointer' onClick={() => {
                localStorage.setItem("addToHomeModalShown", shouldShowModal + 1);
                setOpen(false);
              }} />
            </div>
            <div className="mt-6 flex flex-col gap-2 justify-stretch">
              <h3 className="text-[24px] font-semibold">
                The Sports Guardian app can be added to your phone home screen
              </h3>
              <p className="text-sportsDarkGrey mb-[26px]">
                This app is a Progressive Web App (PWA) and can be added to your
                home screen for easy access and a better experience.
                {isSafari ? (
                  <>
                    <p className="mt-4">
                      This browser{" "}
                      <span className="font-semibold underline text-black">
                        doesn&apos;t support
                      </span>{" "}
                      automatic web app installation, but you can manually install
                      this site through the browser menu.
                    </p>
                    <p className="mt-4">
                      For steps on how to manually add this app to your home screen{" "}
                      <span className="font-semibold underline text-black">
                        <Link to="https://support.apple.com/en-in/guide/iphone/iph42ab2f3a7/ios#iph4f9a47bbc" target="_blank">click here</Link>
                      </span>.
                    </p>
                  </>
                ) : (
                  ``
                )}
                {shouldShowModal === 2 && (
                  <p className="text-sportsDarkGrey mt-4 font-bold">This notification will not appear again.</p>
                )}
              </p>
              <Button
                variant="primary"
                onClick={isSafari ? () => { localStorage.setItem("addToHomeModalShown", shouldShowModal + 1), setOpen(false) } : handleAddToHomeScreenClick}
              >
                {isSafari ? "Got it" : "Add to Home Screen"}
              </Button>
            </div>
          </div>
        );
      }
    };

    useEffect(() => {
      const checkAppInstalled = async () => {
        const installed = await isAppInstalled();
        if (!installed && prompt) {
          addToHomeModal();
        } else if (!installed && isSafari)
        {
          addToHomeModal();
        }
      };

      checkAppInstalled();
    }, [prompt]);

    const handleAddToHomeScreenClick = () => {
      prompt.prompt();

      prompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          // LogErrors(user, logout, updateTokens, "The app was added to the home screen");
          // Store in local storage that the modal has been shown
          localStorage.setItem("addToHomeModalShown", true);
        } else {
          LogErrors(user, logout, updateTokens, "The app was not added to the home screen");
        }
      });
    };

  return (
    <div className="flex flex-col gap-6">
      {theme === "participant" ? (
        <>
          <Logo className="!w-[110px] !h-[40px] mb-2" />

          <div className="mb-2">
            <span className="font-semibold">W E L C O M E</span>
            <h2>Hello {user?.firstName || "Guest"}</h2>
            
            {user?.subscription?.Name && (
              <p 
                style={{
                  "color": user?.subscription?.Name === 'Lite' ? "#C0C0C0" : user?.subscription?.Name === "Bronze" ? "#AD8A56" : user?.subscription?.Name === "Silver" ? "#727272" : "#C9B037",
                }}
              >
                <span className="font-bold">{user?.subscription?.Name}</span>{" "}Subscription
              </p>
            )}
          </div>

          <div className="flex flex-col gap-4 mb-2">
            {user?.subscription?.Name === "Lite" ? (
              <>
                <div className="flex gap-y-[34px] flex-col mb-4">
                  {participants?.slice().reverse().map((participant) => (
                    <Link key={participant?.ParticipantId} to={"/participant/" + participant?.ParticipantId}>
                      <div className="bg-[#F8F8F8] border-[1px] border-[#E3E3E3] h-[200px] rounded-[4px] mr-5 relative flex items-center p-3">
                        <div className="flex flex-col gap-2 font-medium">
                          {participant?.ParticipantName}'s Profile
                        </div>
                        <img
                          src="/images/grey-band.png"
                          alt="band"
                          className="max-w-[175px] mx-auto right-[-20px] absolute"
                        />
                      </div>
                    </Link>
                  ))}
                </div>
                <p className="text-[#6F6F6F]">
                  Want full access to the Sports Guardian app and your own safety band?
                </p>
              </>
            ) : (
              participants?.length > 0 && (
                <>
                  <h3 className="mb-1">My Participants</h3>
                  <div className="flex gap-y-[34px] flex-col mb-4">
                    {participants?.slice().reverse().map((participant) => (
                      <ParticipantCard
                        href={"/participant/" + participant?.ParticipantId}
                        participant={participant}
                        key={participant?.ParticipantId}
                      />
                    ))}
                  </div>
                </>
              )
            )}
            {user?.subscription?.Name !== "Lite" && participants?.some(participant => participant.NotActivatedCount > 0) && (
              <>
                <h3 className="mb-2">Activate New Bands</h3>
                <BandCard triggerModal={BeforeWeBegin} />
              </>
            )}
          </div>

          {/* {user?.subscription?.Name != "Gold" && (
            <div>
              <Button variant="tertiary" className="mx-auto font-poppins font-semibold">
                <Link to="upgrade" state={user}>Upgrade Available</Link>
              </Button>
            </div>
          )} */}
          {user?.subscription?.Name !== "Lite" && (
          <UpgradeAvailable />
          )}
         
            <div className="mt-4">
              <Button
                variant="primary"
                onClick={user?.subscription?.Name === 'Lite' ? handleOrderBandClick : undefined}
                href={user?.subscription?.Name === 'Lite' ? undefined : '/shop/my-participants'}
                className="w-full"
              >
                {user?.subscription?.Name === 'Lite' ? 'Order Your Band' : 'Order New Band'}
              </Button>
              {user?.subscription?.Name === "Lite" && (
                <Button
                  variant="primary"
                  status="nobg"
                  href="/upgrade"
                  className="w-fit mx-auto mt-3 !text-[12px] !text-sportsDarkGrey"
                >
                  <InfoIcon className="w-4 h-4 [&>path]:stroke-sportsDarkGrey" />
                  Find Out More
                </Button>
              )}
            </div>

        </>
      ) : (
        <>
          <div className="flex justify-between items-center mb-5">
            <Logo className="!w-[110px] !h-[40px]" />

              <Link to="/incidents">
                <div className={`rounded p-3 ${incidents?.length > 0 ? "bg-sportsRed" : "bg-[#e3e3e3]"}`}>
                  <IncidentIcon className={`[&>path]:fill-white w-5 h-[22px] inline-block mr-[10px]`} />
                  <span className="text-white font-semibold text-base inline-block align-middle">
                    {incidents?.length > 0 ? incidents?.length : '0' }
                  </span>
                </div>
              </Link>

          </div>

          <div className="mb-2">
            <span className="font-semibold mb-1">W E L C O M E</span>
            <h2 className="mb-2">Hello {user.firstName || "Guest"}</h2>
            <div className="flex gap-1 items-center" onClick={selectedVenue?.zones.length !== 1 && triggerZoneSelectionDrawer}>
              <LocationPinIcon className="w-6 h-6" />
              <p className="text-[16px] leading-[26px]">
                <span className="text-sportsGrey">Currently at </span>{" "}
                <span className="border-b border-b-black">
                   {selectedZone?.ZoneName}
                </span>
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-[19px] mb-11">
            <ContentCard
              title={participantCounts?.ParticipantCount}
              desc={`${selectedVenue?.OrgPartnerFriendlyName} Participants`}
              type="participants"
              href={`/venues/${selectedVenue?.OrgID}/participants`}
            />
            <div className="flex gap-[18px]">
              <ContentCard
                title="Normal</br>Scan"
                href={"/scan?type=normal"}
                htmlTitle={true}
                className="bg-sportsBlue"
                type="scan"
                icon="/images/icons/normalScan.svg"
              />
              <ContentCard
                title="Emergency</br>Scan"
                htmlTitle={true}
                className="bg-sportsRed"
                type="scan"
                href={"/scan?type=emergency"}
                icon="/images/icons/emergencyScan.svg"
              />
            </div>
            <Link to="/guest-bands" className="w-full justify-stretch flex flex-col">
              <Button
                variant="tertiary"
                className="font-semibold border-[1px] bg-[#F8F8F8] border-[#E3E3E3] hover:shadow-none"
              >
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.6493 10.73C13.4493 10.31 13.0293 10.02 12.5293 10.02H11.2793C10.5893 10.02 10.0293 10.58 10.0293 11.27V12.52C10.0293 13.02 10.3193 13.44 10.7393 13.64C11.5293 12.5 12.5193 11.51 13.6593 10.72L13.6493 10.73Z" fill="#101820"/>
                  <path d="M10.7295 26.47C10.3095 26.67 10.0195 27.09 10.0195 27.59V28.84C10.0195 29.53 10.5795 30.09 11.2695 30.09H12.5195C13.0195 30.09 13.4395 29.79 13.6395 29.38C13.1695 29.05 12.7095 28.7 12.2795 28.3C11.6895 27.75 11.1695 27.13 10.7195 26.47H10.7295Z" fill="#101820"/>
                  <path d="M33.8596 31.3501H32.5996C31.9093 31.3501 31.3496 31.9097 31.3496 32.6001V33.8601C31.3496 34.5505 31.9093 35.1101 32.5996 35.1101H33.8596C34.55 35.1101 35.1096 34.5505 35.1096 33.8601V32.6001C35.1096 31.9097 34.55 31.3501 33.8596 31.3501Z" fill="#101820"/>
                  <path d="M23.8205 31.3501H22.5605C21.8702 31.3501 21.3105 31.9097 21.3105 32.6001V33.8601C21.3105 34.5505 21.8702 35.1101 22.5605 35.1101H23.8205C24.5109 35.1101 25.0705 34.5505 25.0705 33.8601V32.6001C25.0705 31.9097 24.5109 31.3501 23.8205 31.3501Z" fill="#101820"/>
                  <path d="M33.8596 21.3101H32.5996C31.9093 21.3101 31.3496 21.8697 31.3496 22.5601V23.8201C31.3496 24.5104 31.9093 25.0701 32.5996 25.0701H33.8596C34.55 25.0701 35.1096 24.5104 35.1096 23.8201V22.5601C35.1096 21.8697 34.55 21.3101 33.8596 21.3101Z" fill="#101820"/>
                  <path d="M30.1005 12.53V11.28C30.1005 10.59 29.5405 10.03 28.8505 10.03H27.6005C27.1005 10.03 26.6805 10.32 26.4805 10.74C27.6205 11.53 28.6105 12.52 29.4005 13.66C29.8205 13.46 30.1105 13.04 30.1105 12.54L30.1005 12.53Z" fill="#101820"/>
                  <path d="M8.14 16.2901C7.79 16.2901 7.51 16.0101 7.51 15.6601V8.14006C7.51 7.79006 7.79 7.51006 8.14 7.51006H15.67C16.02 7.51006 16.3 7.79006 16.3 8.14006V9.40006C17.1 9.12006 17.94 8.91006 18.81 8.82006V8.15006C18.81 6.42006 17.41 5.01006 15.67 5.01006H8.14C6.41 5.00006 5 6.40006 5 8.14006V15.6701C5 17.4001 6.4 18.8101 8.14 18.8101H8.81C8.91 17.9401 9.11 17.1001 9.39 16.3001H8.13L8.14 16.2901Z" fill="#101820"/>
                  <path d="M16.29 31.9801C16.29 32.3301 16.01 32.6101 15.66 32.6101H8.14C7.79 32.6101 7.51 32.3301 7.51 31.9801V24.4501C7.51 24.1001 7.79 23.8201 8.14 23.8201H9.4C9.11 23.0101 8.91 22.1701 8.81 21.3101H8.14C6.41 21.3101 5 22.7101 5 24.4501V31.9801C5 33.7101 6.4 35.1201 8.14 35.1201H15.67C17.4 35.1201 18.81 33.7101 18.81 31.9801V31.3101C17.95 31.2201 17.11 31.0201 16.3 30.7301V31.9801H16.29Z" fill="#101820"/>
                  <path d="M31.9805 5H24.4505C22.7205 5 21.3105 6.4 21.3105 8.14V8.81C22.1805 8.91 23.0205 9.11 23.8205 9.39V8.13C23.8205 7.78 24.1005 7.5 24.4505 7.5H31.9805C32.3305 7.5 32.6105 7.78 32.6105 8.13V15.66C32.6105 16.01 32.3305 16.29 31.9805 16.29H30.7205C31.0005 17.09 31.2105 17.93 31.3005 18.8H31.9705C33.7005 18.8 35.1105 17.4 35.1105 15.66V8.14C35.1105 6.41 33.7005 5 31.9705 5H31.9805Z" fill="#101820"/>
                  <path d="M26.4709 29.38C26.6709 29.8 27.0909 30.1 27.5909 30.1H28.8409C29.5309 30.1 30.0909 29.54 30.0909 28.85V27.6C30.0909 27.1 29.8009 26.68 29.3809 26.48C28.9309 27.14 28.4109 27.76 27.8209 28.31C27.4009 28.71 26.9409 29.07 26.4609 29.39L26.4709 29.38Z" fill="#101820"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M20.06 11C15.06 11 11 15.06 11 20.06C11 25.06 15.06 29.12 20.06 29.12C25.06 29.12 29.12 25.06 29.12 20.06C29.12 15.06 25.06 11 20.06 11ZM20.06 13.42C21.53 13.42 22.72 14.61 22.72 16.08C22.72 17.55 21.53 18.74 20.06 18.74C18.59 18.74 17.4 17.55 17.4 16.08C17.4 14.61 18.59 13.42 20.06 13.42ZM24.81 25.1C24.79 25.27 24.69 25.42 24.55 25.5C23.18 26.28 21.64 26.69 20.06 26.69C18.43 26.69 16.89 26.26 15.57 25.5C15.42 25.42 15.33 25.27 15.31 25.1C15.19 24.01 15.45 22.92 16.03 22C16.91 20.62 18.43 19.79 20.06 19.79C22.7 19.79 24.84 21.92 24.84 24.56C24.84 24.74 24.84 24.92 24.81 25.1Z" fill="#101820"/>
                </svg>

                Guest Bands
              </Button>
            </Link>
            {/* <Link to="/bookings" className="w-full justify-stretch flex flex-col">
              <Button
                variant="tertiary"
                className="font-semibold border-[1px] bg-[#F8F8F8] border-[#E3E3E3] hover:shadow-none"
              >
                <BookingsIcon className="w-10 h-10 [&>path]:stroke-black" />
                Bookings
              </Button>
            </Link> */}
          </div>

          <div className="flex flex-col gap-6">
            <h3>Participants By Zone</h3>
            <div className="flex flex-col gap-[19px] mb-[1px]">
              <div className="flex flex-wrap gap-y-[15px] justify-between">
                {selectedVenue?.zones?.map((zone) => {
                  const matchingParticipantCount = participantCounts?.ParticipantsByZone?.find(
                    (participantZone) => participantZone.ZoneID === zone.ZoneID
                  );

                  return (
                    <ContentCard
                      key={zone.ZoneID}
                      title={matchingParticipantCount ? matchingParticipantCount.ParticipantCount : 0}
                      desc={zone?.ZoneName}
                      type="participants"
                      href={`/venues/${selectedVenue?.OrgPartnerID}/zones/${zone?.ZoneID}`}
                      className="aspect-square"
                      containerClassName="w-[48%]"
                      data={zone}
                    />
                  )
                })}
              </div>
            </div>

            <Button
              className="w-fit mx-auto font-semibold"
              variant="tertiary"
              onClick={() => handleClearVenue("Clear Venue", false)}
            >
              <CloseIcon className="w-4 h-4" />
              Clear Venue
            </Button>
          </div>
        </>
      )}
    </div>
  );
}